import React from 'react'
import styles from './styles.module.css'
import Tooltip from '@mui/material/Tooltip'
import infoIcon from '../../../../images/circle-info-regular-full.svg'

function RawCategories ({ localRawCategory, setLocalRawCategory }) {
  const handleRawCategory = event => {
    setLocalRawCategory(event.target.value)
  }

  return (
    <div>
      <div>
        <div className={styles.RawCategoryInputWrapper}>
          <div className={styles.inlineLabel}>
            <label className={styles.RawCategoryLabel}>Raw categories</label>
            <Tooltip
              title='Filter by the raw category text as it appears on the source page. Useful if normalized categories are missing or inconsistent.'
              arrow
              placement='top'
              slotProps={{
                popper: {
                  sx: {
                    '& .MuiTooltip-tooltip': {
                      maxWidth: 500,
                      fontSize: '13px',
                      padding: '8px'
                    }
                  }
                }
              }}
            >
              <img
                src={infoIcon}
                alt='Raw categories help'
                width={14}
                height={14}
                className={styles.infoIcon}
                tabIndex={0}
              />
            </Tooltip>
          </div>

          <input
            className={styles.RawCategoryInput}
            type='text'
            id='prevent_autofill'
            autoComplete='off'
            placeholder='Text'
            value={localRawCategory}
            onChange={handleRawCategory}
          />
        </div>
      </div>
    </div>
  )
}

export default RawCategories
